import { Component } from 'react';

// @ts-expect-error - bender-url is not typed
import defaultContactImage from 'bender-url!avatar-components/images/default-avatar.png';
import { AVATAR_SIZES, RETINA_MULTIPLIER } from './Constants';
// @ts-expect-error - MD5 is not typed
import MD5 from './lib/MD5';
import envSuffix from './lib/envSuffix';
import { AvatarDisplay } from './AvatarDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
export class UnauthedHubSpotUserAvatar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgSrc: ''
    };
  }
  componentDidMount() {
    const imageURI = this.getHubSettingsUrl();
    if (this.props.hideDefaultAvatar) {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', imageURI);
      xhr.onerror = () => {
        return this.setState({
          imgSrc: ''
        });
      };
      xhr.onload = () => {
        const img = new Image();
        const response = xhr.responseText;
        let binary = '';
        for (let i = 0; i < response.length; i++) {
          // eslint-disable-next-line no-bitwise
          binary += String.fromCharCode(response.charCodeAt(i) & 0xff);
        }
        img.src = `data:image/jpeg;base64${btoa(binary)}`;
        return this.setState({
          imgSrc: img.src
        });
      };
      xhr.overrideMimeType('text/plain; charset=x-user-defined');
      xhr.send();
    }
    return this.setState({
      imgSrc: imageURI
    });
  }
  getEmailHash() {
    const {
      hubSpotUserEmail
    } = this.props;
    return MD5((hubSpotUserEmail || '').toLowerCase());
  }
  getHubSettingsUrl() {
    const {
      hubSpotUserEmail,
      size
    } = this.props;
    if (typeof hubSpotUserEmail === 'undefined') {
      return defaultContactImage;
    }
    const sizePx = size !== 'responsive' ? AVATAR_SIZES[size] : AVATAR_SIZES.xl;
    const doubleDimensionForRetina = sizePx * RETINA_MULTIPLIER;
    return `https://app.hubspot${envSuffix()}.com/hubsettings/v1/avatar/hash/${this.getEmailHash()}/${doubleDimensionForRetina}`;
  }
  render() {
    const {
      displayName,
      hubSpotUserEmail,
      size
    } = this.props;
    return this.state.imgSrc ? /*#__PURE__*/_jsx(AvatarDisplay, {
      size: size,
      displayName: displayName || hubSpotUserEmail,
      src: this.state.imgSrc
    }) : null;
  }
}
UnauthedHubSpotUserAvatar.defaultProps = {
  size: AvatarDisplay.defaultProps.size
};